<template>
  <div>
    <el-card>
      <el-tabs v-model="activeTab" type="card" @tab-click="workStatisticFunc">
        <el-tab-pane :label="$t('detail')" name="0">
          <search-form @getData="getData"/>
          <work-detail :data="data" :loading="loading" @getData="getData"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('myProject')" name="1">
          <my-work-search-form @getData="getData"></my-work-search-form>
          <my-work :data="data" :loading="loading" @getData="getData"></my-work>
        </el-tab-pane>
        <el-tab-pane :label="$t('projectStatus')" name="2">
          <work-statistic ref="statistic"></work-statistic>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import myWorkSearchForm from './myWorkSearchForm'
import SearchForm from './searachForm'
import WorkDetail from './workDetail'// 作品列表component
import workStatistic from './workStatistic'// 作品统计component
import myWork from './myWork'
import { workScoreFilter, formatDate } from '@/utils/utils'
export default {
  components: {
    WorkDetail,
    workStatistic,
    myWork,
    SearchForm,
    myWorkSearchForm
  },
  data() {
    return {
      activeTab: '0',
      loading: false,
      data: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      if (this.activeTab === '0') {
        const res = await this.$store.dispatch('workManageGetData')
        this.loading = false
        if (res.status < 400) {
          this.data = res.data.items
          this.data.forEach((value) => {
            value.rate = workScoreFilter(value.score)
            value.selfRate = workScoreFilter(value.self_score)
            value.mutualScore = workScoreFilter(value.mutual_score)
            value.creativeScore = workScoreFilter(value.creative_score)
            value.artisticScore = workScoreFilter(value.artistic_score)
            value.logicalScore = workScoreFilter(value.logical_score)
            value.programmingScore = workScoreFilter(value.programming_score)
          })
        }
      }

      if (this.activeTab === '1') {
        const res = await this.$store.dispatch('getTeacherWork')
        this.loading = false
        if (res.status < 400) {
          this.data = res.data.items
        }
      }
    },
    workStatisticFunc(a) {
      this.$store.commit('workManageInit')
      this.$store.commit('switchTab', a.index)
      this.getData()
      if (a.index === '2') {
        this.month = this.month || formatDate(void 0, 'Y-m')
        this.$refs.statistic.classSelect()
        this.$refs.statistic.classChange()
      }
    }
  }
}
</script>
<i18n lang="yaml">
en:
  detail: Detail
  myProject: My projects
  projectStatus: Project status
zh-CN:
  detail: 作品明细
  myProject: 我的作品
  projectStatus: 学生作品统计
zh-TW:
  detail: 作品明細
  myProject: 我的作品
  projectStatus: 學生作品統計
it:
  detail: Dettaglio
  myProject: I miei progetti
  projectStatus: Stato del progetto
id:
  detail: Rincian
  myProject: Karya saya
  projectStatus: Status karya
</i18n>
